//メニュープログラム

$(function() {
 
  //外側の要素にマウスを乗せたら発動
  $('.menu_1_list').mouseover(function() {
 
    //アニメーションしながらテキストサイズが大きくなる
    $(this).children().addClass('active');
 
  //ここにはマウスを離したときの動作を記述
  }).mouseout(function() {
 
    //アニメーションしながらテキストサイズが元のサイズに戻る
    $(this).children().removeClass('active');
 
  });
});

/**
$(function() {

$('.hed_menu p').on('click', function() {
  $('.lochide_a').removeClass("active");
  $('.loctit_a').removeClass("active");
  $(this).parent(".loctit_a").toggleClass("active");
  $(this).next('.lochide_a').toggleClass("active");
});

});

**/


$(function() {

  $('.hed_menu p').on('click', function() {
    $(".nav_all_sp").toggleClass("active");
  });
  
  });